import { render } from "./RestoreConfirmModal.vue?vue&type=template&id=8b58ef2c"
import script from "./RestoreConfirmModal.vue?vue&type=script&lang=js"
export * from "./RestoreConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__